export default __webpack_public_path__ + "static/media/steps-cover-1.7c7a9a7f.png";